/*
   存儲數據
*/

import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
// reducer 對應到相對的數據改變方法
import reducer from './reducer'


export default createStore(reducer, composeWithDevTools(applyMiddleware(thunk)))